module.exports = __webpack_public_path__ + "img/avatar-s-22.4ec94f65.jpg";